<template>
    <div class="d-flex flex-column min-vh-100">
        <div class="container">
            <nav class="navbar navbar-light">
                <ul class="navbar-nav mr-auto" v-if="$state.logged_in">
                    <!-- Hack for equal width -->
                    <li class="nav-item">
                        <a class="nav-link" href="#" style="visibility: hidden">{{$t('global_help')}}</a>
                    </li>
                </ul>
                <div class="m-auto">
                    <router-link class="navbar-brand" :to="{name: 'welcome'}">
                        <span v-if="$state.login_info.logo">
                            <img class="client-brand" v-bind:src="$state.login_info.logo"/>
                        </span>
                        <span class="client-brand-name" v-else-if="$state.login_info.bedrijfsnaam">
                        {{$state.login_info.bedrijfsnaam}}
                        </span>
                        <span v-else>
                            <img v-bind:src="'/img/logo_' + lang + '.png'" style="max-height: 50px" alt="Movaview">
                        </span>
                    </router-link>
                </div>
                <ul class="navbar-nav ml-auto" v-if="$state.logged_in">
                    <li class="nav-item">
                        <router-link class="nav-link text-muted" :to="{name: 'logout'}">{{ $t('global_logout') }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link text-muted" to="#" data-toggle="modal" data-target="#modal-help"><i class="fa fa-question-circle"></i> {{ $t('global_help') }}</router-link>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="container d-flex flex-row align-items-stretch justify-content-center" style="flex: 1">
            <div class="row justify-content-center w-100">
                <router-view></router-view>
            </div>
        </div>
        <footer class="bg-light">
            <p class="text-center text-muted my-2">
                Movaview
            </p>
        </footer>
        <modal-help></modal-help>
    </div>
</template>


<script>
    import ModalHelp from '@/views/ModalHelp';
    export default {
        name: 'app',
        components: { ModalHelp },
        computed: {
            lang() {
                return this.$state.login_info.taal === "1" ? 'nl' : 'en';
            }
        }
    }
</script>
